module.exports = __webpack_public_path__ + "static/media/briefcase.029782c8.svg";